import React from 'react';
import { Form } from 'formik';
import {
  InputCurrencyField,
  InputField,
  InputPercentageField,
  ReactSelectField,
  ReactCreatableSelectField,
  SwitchField
} from '@oforce/global-components';

import { useAccountTags } from '../../../views/account/hooks';
import {
  useFeeRateModes,
  useProductFeeOptions,
  useProductPricingOptions
} from '../../../components/sharedComponents/pricing';

import { useFeeAppliesToOptions } from '../hooks';
import { useActiveAccount } from '../../../shared/activeAccount';
import { useProrateSettings } from '../../pricing/hooks';
import { Render } from '../../../components';

export default function FeeForm({ product, formik, fee }) {
  const { id: activeAccountId } = useActiveAccount();
  const { tagOptions } = useAccountTags({ accountId: activeAccountId });

  const { feeRateModeOptions: rateModeOptions } = useFeeRateModes();
  const { feeAppliesToOptions } = useFeeAppliesToOptions();
  const { selectOptions: options, loading } = useProductPricingOptions({ productId: product?.id });
  const { selectOptions: feeOptions, loading: feeOptionsLoading } = useProductFeeOptions({
    productId: product?.id,
    fee
  });

  const {
    PRORATE_SETTINGS: { NO_PRORATE }
  } = useProrateSettings();

  const prorateFee = formik?.values?.prorated;

  return (
    <Form>
      <InputField required label="Name" name="name" placeholder="Enter a fee name" />
      <ReactSelectField required label="Rate Mode" options={rateModeOptions} name="rateMode" />

      {formik?.values?.rateMode?.value !== 'FLAT' ? (
        <InputPercentageField name="rate" label="Rate" options={{ decimalLimit: 4 }} required />
      ) : (
        <InputCurrencyField options={{ integerLimit: 5 }} name="rate" label="Rate" required />
      )}
      <Render if={product?.prorateSetting !== NO_PRORATE}>
        <SwitchField
          id="enable-prorate-fee-switch"
          className="mb-3"
          label="Prorate"
          name="prorated"
          size="sm"
          switchLabel={prorateFee ? 'Enabled' : 'Disabled'}
        />
      </Render>
      {formik?.values?.rateMode?.value === 'PREMIUM_PLUS' && (
        <ReactSelectField
          required
          label="Premium PLUS Fees"
          name="multipliers"
          options={feeOptions}
          placeholder="Select..."
          isMulti
          isLoading={feeOptionsLoading}
          disabled={feeOptionsLoading}
          clearable
        />
      )}
      <ReactSelectField
        required
        className="mt-3"
        label="Applies to"
        options={feeAppliesToOptions}
        name="appliesToAllPricingOptions"
      />
      {!formik?.values?.appliesToAllPricingOptions?.value && (
        <ReactSelectField
          required
          label="Selected Pricing Options"
          name="productPricings"
          options={options}
          placeholder="Select..."
          isMulti
          isLoading={loading}
          disabled={loading}
          clearable
        />
      )}
      <ReactCreatableSelectField
        options={tagOptions}
        isMulti
        name="tags"
        label="Tags"
        onCreateOption={tag => {
          const tags = formik.values.tags;
          tags.push({ value: tag, label: tag });
          formik.setFieldValue('tags', tags);
        }}
        placeholder="Choose or Create Tags..."
      />
    </Form>
  );
}
